/**
 * The body of `POST /api/dashboard/results` for "Season vs last year" (CU-869fmhmx8 D3, D4). Only what changes the
 * data travels: Min / Avg / Max, sorting, searching, "Show last year's price", Tiers and Providers are local; the
 * cars filter is not (E1): one kind with its values, a group by its id.
 */
import { toCompact } from '../../../@services/dates.js'
import { PERIOD_COMP } from '../../../@services/explorerLink.js'
import { carsBody } from '../../../@services/cars.js'

export const REPORT_TYPE = 'season-vs-last-year'

export function buildRequestBody({ view, pickup, capture, currency }) {
	return {
		reportType: REPORT_TYPE,
		officePickupID: view.office,
		lor: view.lor,
		currency: currency ?? null,
		startPickupDate: toCompact(pickup.from),
		endPickupDate: toCompact(pickup.to),
		startBookingDate: toCompact(capture.from),
		endBookingDate: toCompact(capture.to),
		groupBy: view.by,
		isPreviousComparison: true,
		periodComp: { ...PERIOD_COMP[view.cmp] },
		sameWeekday: view.cmp === 'ly' && !view.same,
		isNewVersion: true,
		...carsBody(view),
	}
}

/** The fields whose change asks the server again (D12) */
export const dataKey = body => JSON.stringify(body)
